import React, { Component } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { Button } from "reactstrap";
import { isObject } from "lodash";
import StyledFirebaseAuth from "react-firebaseui/StyledFirebaseAuth";
import TranslationMain from "./components/pages/TranslationMain";
import DebugPage from "./components/pages/DebugPage";
import { auth, googleAuthProvider, emailAuthProvider } from "./components/common/firebase";
import { getUserProfile, sendValidationEmail } from "./components/common/helper";
import UserAdministration from "./components/user/UserAdministration";
import Loading from "./components/pages/Loading";
import "./App.css";

class App extends Component {
  state = {
    user: "",
    access: null,
    defaultValue: null,
    loading: false
  };

  uiConfig = {
    signInFlow: "popup",
    signInOptions: [googleAuthProvider, emailAuthProvider],
    callbacks: {
      signInSuccessWithAuthResult: () => false
    }
  };

  componentDidMount = () => {
    auth.onAuthStateChanged(this.setCurrentUser, error => console.error(error));
  };

  setCurrentUser = user => {
    this.setState({ user, loading: true });
    if (user)
      getUserProfile(user.email)
        .then(doc => {
          let data = null;
          if (doc) data = doc.data();
          if (data) {
            const { access, defaultValue, canSeeFinance, canSave, canPublish, isAdmin, canDownloadBase } = data;

            let newAccess = access;
            if (!isObject(newAccess)) newAccess = JSON.parse(access);

            this.setState({
              access: newAccess,
              defaultValue,
              canSeeFinance,
              canSave,
              canPublish,
              isAdmin,
              canDownloadBase
            });
          } else {
            this.setState({ access: null, defaultValue: null });
          }
          this.setState({ loading: false });
        })
        .catch(err => {
          this.setState({ loading: false });
          console.error(err);
        });
    else {
      this.setState({ loading: false });
    }
  };

  logOut = () => {
    auth
      .signOut()
      .then(() => {
        this.setState({ user: "" });
      })
      .catch(() => {
        toast.error("Error on Log out");
      });
  };

  render() {
    const {
      user,
      access,
      defaultValue,
      loading,
      canSeeFinance,
      canPublish,
      canSave,
      isAdmin,
      canDownloadBase
    } = this.state;

    if (loading) return <Loading />;

    if (!user) {
      return (
        <section id="page-splash">
          <ToastContainer />
          <div className="LoginBox">
            <h3 className="fp-logo">CMS - Translator Tool</h3>
            <div className="fp-caption">Please use one of the following Sign in methods</div>
            <div className="fp-signed-out-only">
              <StyledFirebaseAuth uiConfig={this.uiConfig} firebaseAuth={auth} />
            </div>
          </div>
        </section>
      );
    }

    if (!access || !defaultValue) {
      return (
        <section id="page-splash">
          <ToastContainer />
          <div className="LoginBox">
            <h3 className="fp-logo">CMS - Translator Tool</h3>
            <div className="fp-caption-noaccess">
              {user.emailVerified
                ? "You don't have access to anything yet, please call your administrator, or login with a different account"
                : "You need to verify your email"}
            </div>
            <div className="fp-signed-out-only">
              {!user.emailVerified ? (
                <div>
                  <Button color="primary" onClick={sendValidationEmail}>
                    Send Validation email
                  </Button>
                </div>
              ) : (
                ""
              )}
              <br />
              <div>
                <Button color="primary" onClick={this.logOut}>
                  Log Out
                </Button>
              </div>
            </div>
          </div>
        </section>
      );
    }

    return (
      <BrowserRouter>
        <Switch>
          <Route
            exact
            path="/"
            render={props => (
              <TranslationMain
                {...props}
                user={user}
                access={access}
                defaultValue={defaultValue}
                logOut={this.logOut}
                canSeeFinance={canSeeFinance}
                canSave={canSave}
                canPublish={canPublish}
                canDownloadBase={canDownloadBase}
                isAdmin={isAdmin}
              />
            )}
          />
          <Route
            exact
            path="/debug"
            render={props => (
              <DebugPage
                {...props}
                user={user}
                access={access}
                defaultValue={defaultValue}
                logOut={this.logOut}
                canSeeFinance={canSeeFinance}
                canSave={canSave}
                canDownloadBase={canDownloadBase}
                canPublish={canPublish}
                isAdmin={isAdmin}
              />
            )}
          />
          <Route
            exact
            path="/UserAdministration"
            render={props => <UserAdministration {...props} user={user} logOut={this.logOut} />}
          />
        </Switch>
      </BrowserRouter>
    );
  }
}

export default App;
